import React from 'react';
import PropTypes from 'prop-types';
import currencyFormatter from 'currency-formatter';
import _ from 'lodash';

const CurrencyCell = props => (
  <div className="rt-td--default">
    <span>
      {_.has(props.value, 'total_cost')
        ? currencyFormatter.format(props.value.total_cost, { code: props.value.currency })
        : null}
    </span>
  </div>
);

CurrencyCell.propTypes = {
  value: PropTypes.shape({
    total_cost: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    currency: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  }),
};

export default CurrencyCell;
